import {BrowserRouter, Route, Navigate, useLocation, Routes} from 'react-router'
import RouterV2Assessments from '@freckle/school/ts/common/routers/router-v2/assessments'
import RouterV2Common from '@freckle/school/ts/common/routers/router-v2/common'
import RouterV2Error from '@freckle/school/ts/common/routers/router-v2/error'
import RousterV2Rostering from '@freckle/school/ts/common/routers/router-v2/rostering'
import RouterV2Reports from './reports'

export default function RouterV2() {
  return (
    <BrowserRouter>
      <Routes>
        {RouterV2Common()}
        {RouterV2Assessments()}
        {RouterV2Reports()}
        {RousterV2Rostering()}
        {RouterV2Error()}
        {/* Temporary redirect after switching from HashRouter to BrowserRouter */}
        {/* This will redirect every # leading url to their non-hash based url */}
        <Route path="/" element={<ConditionalRedirect />} />
      </Routes>
    </BrowserRouter>
  )
}

function ConditionalRedirect() {
  const location = useLocation()
  if (location.hash.length > 0) {
    return <Navigate to={location.hash.replace('#', '')} replace />
  }
  return <Navigate to="/login" replace />
}
